import { AddTask } from '@mui/icons-material';
import {
  Typography,
  Grid,
  Box,
  Skeleton,
  useMediaQuery,
  Button,
  Stack,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyStatus } from '../../common/enums/enums';
import { isReconditioning } from '../../helpers/reconditioning';
import WOrderTag from './WOrderTag';

export default function WOrderTagGrid({
  data,
  isLoading,
  history,
  enableAddEstimate,
  onNewEstimateClick,
  handleStartDone,
  addTechnician,
  hasActionsEnabled = true,
}) {
  const theme = useTheme();
  const numberSquareSkeletons = useMediaQuery(theme.breakpoints.down('md'))
    ? 2
    : 4;

  const shouldEnableButtons =
    data?.vendor?.companyStatus === CompanyStatus.ACTIVE &&
    data?.dealer?.companyStatus === CompanyStatus.ACTIVE;

  const { t } = useTranslation('workOrdersTable');
  return (
    <>
      {data?.relatedOrders && data?.relatedOrders.length !== 0 && (
        <Box
          sx={{
            p: { xs: 2, lg: 4 },
            bgcolor: 'background.paper',
            borderTop: '1px solid',
            borderColor: theme.palette.divider,
          }}
        >
          <Grid container flexDirection="column">
            <Grid item>
              <Typography variant="subtitle1" color="textPrimary">
                {!isLoading ? (
                  t('detail.orderTagGrid.title')
                ) : (
                  <Skeleton variant="text" width={120} />
                )}
              </Typography>
            </Grid>
            <Grid item>
              <Grid
                container
                flexDirection="row"
                paddingTop={2}
                flexWrap={{ xs: 'wrap', sm: 'nowrap' }}
                gap={2}
              >
                {!isLoading ? (
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    alignItems={{ xs: 'unset', md: 'center' }}
                    gap={1}
                    flexGrow={1}
                    width="1px"
                    sx={{ overflow: { sm: 'auto' } }}
                    p={{
                      sm: 1,
                      lg: 0,
                    }}
                  >
                    {data?.relatedOrders.map((relatedOrder, index) => (
                      <WOrderTag
                        data={relatedOrder}
                        history={history}
                        handleStartDone={handleStartDone}
                        addTechnician={() => addTechnician(relatedOrder)}
                        hasActionsEnabled={hasActionsEnabled}
                        key={index}
                      />
                    ))}
                    {enableAddEstimate && isReconditioning(data) && (
                      <Button
                        sx={{
                          minWidth: { xs: '100%', sm: '299px' },
                          minHeight: '68.95px',
                          maxHeight: '68.95px',
                          borderRadius: '4px',
                          border: '1px dashed rgba(0, 0, 0, 0.23)',
                          order: { xs: 0, sm: 1 },
                        }}
                        startIcon={<AddTask />}
                        disabled={!shouldEnableButtons}
                        onClick={() => onNewEstimateClick(data)}
                      >
                        {t('vehicleTable.kebab.menu2')}
                      </Button>
                    )}
                  </Stack>
                ) : (
                  <>
                    {[...Array(numberSquareSkeletons)].map((_, index) => (
                      <Grid
                        item
                        marginRight={{ sm: 2 }}
                        marginBottom={{ xs: 2 }}
                        key={index}
                      >
                        <Skeleton
                          variant="rectangular"
                          height={'62px'}
                          width={'240px'}
                        />
                      </Grid>
                    ))}
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
}
